import { StateSetter } from 'react';

import { SuggestionWithUser } from 'entities';

import { Column, Card, Row, IconButton } from 'components/Blocks';
import { EntityStatusTag } from 'components/Entities';
import { MultiLineText } from 'components/MultiLineText';
import { UserAvatar } from 'components/UserAvatar';
import { ChatIcon, ExpandIcon, FilePlusIcon } from 'components/Icons';

import { UpvoteSuggestionButton } from '../UpvoteSuggestionButton';

import { getTimePassed } from 'utils/date';

interface SuggestionCardProps {
  suggestion: SuggestionWithUser;

  openSuggestion?: (id: string) => void;

  updateSuggestion?: StateSetter<SuggestionWithUser>;
}

export function SuggestionCard({
  suggestion,
  openSuggestion,
  updateSuggestion,
}: SuggestionCardProps) {
  const { status, timestamp, text, title, user, files } = suggestion;

  return (
    <Card flow="column" gap="3">
      <Row gap="3">
        <UpvoteSuggestionButton
          suggestion={suggestion}
          className="-ml-2"
          updateSuggestion={updateSuggestion}
        />

        <EntityStatusTag
          target="userSuggestion"
          status={status}
          round={false}
          className="w-fit"
          size="medium"
        />

        {!!openSuggestion && (
          <IconButton onClick={() => openSuggestion(suggestion.id)}>
            <ExpandIcon size={14} />
          </IconButton>
        )}

        <span className="ml-auto text-xs">{getTimePassed(timestamp)}</span>
      </Row>

      <h5 className="text-lg">{title}</h5>

      <Column gap="1">
        <MultiLineText
          text={text}
          renderLine={(line) => <p className="max-w-[95ch] text-justify leading-relaxed">{line}</p>}
        />
      </Column>

      <Row>
        <UserAvatar user={user} name size={32} />

        <Row gap="1" className="ml-auto">
          <FilePlusIcon size={16} />
          <span>{files.length}</span>
        </Row>

        <Row gap="1">
          <ChatIcon size={16} />
          <span>{suggestion.commentCount}</span>
        </Row>
      </Row>
    </Card>
  );
}
